module.exports = __webpack_public_path__ + "img/arrowheads_down.cc6cf90b.svg";